/**
 * VJ — parche "Guardados" (wishlist). No es codigo de HulkApps: parche aditivo del tema.
 * BRIEF_PARCHE_GUARDADOS_2026-09-10.md / DIAGNOSTICO_WISHLIST_2026-09-10.md
 *
 * Causa raiz (medida 2026-09-10, no la provocamos nosotros): al pedir confirmacion, la app llama
 * hulkModalManager._show('deleteItemsPopup'), que AGREGA una copia nueva del popup al final del
 * body; pero hulkapps-wishlist-page.js engancha el Yes con
 * document.querySelector('[data-deleteHulkWishlistItems]').onclick -> la PRIMERA copia, oculta.
 * El Yes visible queda sin handler: con clic humano no sale ninguna peticion y nada se borra.
 * 1) Reenviamos el clic del Yes visible al handler que la app enganchó.
 * 2) Tras el 200 de delete_product (invitada) reconciliamos el DOM contra
 *    /wishlist/products/guest, que es la fuente de verdad.
 *
 * Degrada sin romper: si la app cambia endpoints o markup, el try/catch evita tirar errores de
 * consola y el parche simplemente no hace nada.
 */
(function () {
  'use strict';

  var DELETE_RE = /\/wishlist\/delete_product\/?/i;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Solo invitada: con cliente logueado la app borra en /delete_product (sin /guest) y lista con
  // customer_id + wishlist_id; reconciliar contra la lista de invitada vaciaria su pantalla.
  function scopeFromUrl(url) {
    var m = url.match(/\/wishlist\/delete_product\/([a-zA-Z0-9_-]+)/);
    return m && m[1] === 'guest' ? 'guest' : null;
  }

  function reconcile(scope) {
    try {
      var hw = window.hulkappsWishlist || {};
      var base = hw.baseURL || '/apps/advanced-wishlist/api';
      var shop = hw.domain || (document.querySelector('[data-shop-domain]') || {}).dataset ? undefined : undefined;
      var uuid = scope === 'guest' ? getCookie('hulk_wishlist_UserUUID') : null;

      var qs = 'page=1&per_page=250&search=&country_code=null&sort_by=';
      if (uuid) qs += '&uuid=' + encodeURIComponent(uuid);
      if (hw.domain) qs += '&shop=' + encodeURIComponent(hw.domain);

      var getUrl = base + '/wishlist/products/' + scope + '?' + qs;

      fetch(getUrl, { credentials: 'include' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (!json || !json.data) return;
          var remainingIds = {};
          json.data.forEach(function (item) {
            if (item && item.id != null) remainingIds[String(item.id)] = true;
          });

          var cards = document.querySelectorAll('.wishlist-card[data-id]');
          cards.forEach(function (card) {
            var id = card.getAttribute('data-id');
            if (id && !remainingIds[id]) {
              card.parentNode && card.parentNode.removeChild(card);
            }
          });

          document.dispatchEvent(new CustomEvent('vj:wishlist-reconciled', {
            detail: { scope: scope, remaining: Object.keys(remainingIds).length }
          }));
        })
        .catch(function () {});
    } catch (e) {
      /* degradar en silencio */
    }
  }

  function maybeReconcile(url, ok) {
    if (!ok || !url || !DELETE_RE.test(url)) return;
    var scope = scopeFromUrl(url);
    if (scope) reconcile(scope);
  }

  // fetch
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return origFetch.apply(this, args).then(function (resp) {
        try { maybeReconcile(resp.url || url, resp.ok); } catch (e) {}
        return resp;
      });
    };
  }

  // XMLHttpRequest
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vjUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', function () {
        try { maybeReconcile(this.__vjUrl, this.status >= 200 && this.status < 300); } catch (e) {}
      });
      return origSend.apply(this, arguments);
    };
  }

  // Yes visible sin handler -> reenviar al Yes que la app enganchó (ver causa raiz arriba).
  document.addEventListener('click', function (ev) {
    try {
      var yes = ev.target && ev.target.closest && ev.target.closest('[data-deleteHulkWishlistItems]');
      if (!yes || typeof yes.onclick === 'function') return;
      var bound = null;
      document.querySelectorAll('[data-deleteHulkWishlistItems]').forEach(function (el) {
        if (!bound && el !== yes && typeof el.onclick === 'function') bound = el;
      });
      if (!bound) return;
      ev.preventDefault();
      ev.stopPropagation();
      var handler = bound.onclick;
      bound.onclick = null; // un clic = un borrado; la app lo re-engancha en cada Delete
      handler.call(bound, ev);
    } catch (e) {
      /* degradar en silencio */
    }
  }, true);
})();
